import * as moment from 'moment';

export interface IServiceInstance {
    id: number;
    siteId: number;
    serverId: number;
    selectedServiceType: IServiceOption;
    serviceList: IServiceOption[];
    assetType: string;
    allocatedAssets: IField;
    isBeingEdited: boolean;
    discriminator: string;
}

export interface IServerWithServices {
    name: string;
    serviceInstances: IServiceInstance[];
}

export interface IServiceOption {
    licenseParameters: string;
    licensePassword: string;
    productName: string;
    id: number;
    assetType: {
        id: number;
        assetTypeName: string;
    };
}

export interface IService {
    // id: number;
    selectedServiceType: string;
    serviceList: string[]; // seperate component with list and selected value? enum for types of services?
    assetType: string;
    expirationDate: moment.Moment;
    assetCount: number[]; // sep comp with selected?
    allocatedAssets: number;
    availableAssets: number;
    productOrderNumber: string;
}

export interface ILicenseAllowance {
    id: number;
    siteId: number;
    licensableService: ILicensableService;
    site: ISite;
    productOrderNumber: IField;
    totalAssetAllocation: IField;
    expirationDateUtc: IField;
    isBeingEdited: boolean;
    discriminator: string;
}

export interface IAllocationViewModel {
    allocation: ILicenseAllowance;
    availableAssets: number;
    allocatedAssets: number;
}

export interface ILicensableService {
    id: number;
    assetType: IAssetType;
    licenseParameters: string;
    licensePassword: string;
    productName: string;
}

export interface ISite {
    id: number;
    ServIsId: string;
    SiteName: string;
    Owner: string;
    Operator: string;
    RegionName: string;
    Country: string;
    City: string;
}

export interface IAssetType {
    id: number;
    assetTypeName: string;
}

export interface IServer {
    id: number;
    description: IField;
    serverId: IField;
    operationalUseType: ISelectOption;
    isBeingEdited: boolean;
    serviceAllocations: IServiceInstance[];
    siteId: number;
    discriminator: string;
    isAvailable: boolean;
}

export interface ISelectOption {
    id: number;
    usageName: string;
}

export interface IField {
    value: any;
    valid: boolean;
}

export interface ICustomerSite {
    name: string;
    region: string;
    site: string;
    siteID: string;
    physicalAddress: string;
    shippingAddress: string;
}

export interface IServerState {
    server: IServer[];
    numberOfSavedServers: number;
    serverLoading: boolean;
    serverIsAddingNew: boolean;
    serverEditing: boolean;
    availableServices: IServiceOption[];
    operationalUsages: any[];
    serverErrorMessageVisible: boolean;
}

export interface ILicenseAllowanceState {
    site: any;
    licenseAllowances: ILicenseAllowance[];
    licenseAllowancesLoading: boolean;
    licenseAllowancesIsAddingNew: boolean;
    licenseAllowancesIsEditing: boolean;
    licenseAllowanceErrorMessageVisible: boolean;
}

export interface IServiceOptionsState {
    serviceOptions: any;
    serviceOptionsLoading: boolean;
}

// TODO: names
export interface IServerWithServicesState {
    serviceInstances: IServiceInstance[];
    serviceInstancesEditing: boolean;
    serviceInstancesLoading: boolean;
}

export interface ISiteLicenseState {
    licenseFileLoading: false;
}

export class Allocation implements ILicenseAllowance {
    id: number;
    siteId: number;
    site: ISite;
    expirationDateUtc: IField;
    licensableService: ILicensableService;
    productOrderNumber: IField;
    totalAssetAllocation: IField;
    isBeingEdited: boolean;
    discriminator: string;

    constructor(siteId = -1) {
        this.id = -1;
        this.expirationDateUtc = { value: moment().add(1, 'y').toString(), valid: true };
        this.licensableService = {
            assetType: {
                id: -1,
                assetTypeName: '',
            },
            id: -1,
            licenseParameters: '',
            licensePassword: '',
            productName: ''
        };
        this.productOrderNumber = { value: '', valid: false };
        this.totalAssetAllocation = { value: 0, valid: false };
        this.isBeingEdited = true;
        this.siteId = siteId;
    }
}

export class Server implements IServer {
    id: number;
    description: IField;
    serverId: IField;
    operationalUseType: ISelectOption;
    isBeingEdited: boolean;
    serviceAllocations: IServiceInstance[];
    siteId: number;
    discriminator: string;
    isAvailable: boolean;

    constructor(siteId = -1) {
        this.id = -1;
        this.description = { value: '', valid: false };
        this.serverId = { value: '', valid: false };
        this.operationalUseType = { id: 1, usageName: 'Customer' };
        this.isBeingEdited = true;
        this.serviceAllocations = [];
        this.siteId = siteId;
        this.isAvailable = false;
    }
}

export class ServiceInstance implements IServiceInstance {
    id: number;
    siteId: number;
    serverId: number;
    selectedServiceType: IServiceOption;
    serviceList: IServiceOption[];
    assetType: string;
    allocatedAssets: {
        value: number,
        valid: boolean
    };
    isBeingEdited: boolean;
    discriminator: string;

    constructor(serverWithServicesId = -1, siteId = -1, serviceList = []) {
        this.id = -1;
        this.siteId = siteId;
        this.serverId = serverWithServicesId;
        this.serviceList = serviceList;
        this.allocatedAssets = {
            value: 0,
            valid: false
        };
        this.isBeingEdited = true;
        this.selectedServiceType = {
            licenseParameters: '',
            licensePassword: '',
            productName: '',
            id: -1,
            assetType: {
                id: -1,
                assetTypeName: ''
            }
        };
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/models.ts